import { useMemo } from "react"
import _ from "lodash"

import { SponsoredContentFeature, useGetFooterBanners } from "venue-react"
import { useSponsoredContent } from "./useSponsoredContent"

interface IFooterBannerConfig {
  disable?: boolean
  limit?: number
  autoplay?: boolean
  interval?: number
}

interface IUseSponsoredFooterBannerResult {
  footerBanners: SponsoredContentFeature[]
  footerBannerConfig: IFooterBannerConfig
}

export const useSponsoredFooterBanner = (): IUseSponsoredFooterBannerResult => {
  const { footerBanner } = useSponsoredContent()
  const footerBannerConfig = useMemo(
    () => _.get(footerBanner, "config"),
    [footerBanner]
  )

  const { data: footerBanners = [] } = useGetFooterBanners()

  return {
    footerBanners,
    footerBannerConfig,
  }
}
